var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rounded-3xl overflow-hidden"},[_c('el-menu',{staticClass:"desktop-menus",attrs:{"default-active":_vm.activeMenu,"collapse":_vm.collapse}},_vm._l((_vm.permission_routes),function(route){return _c('menus-item',{key:route.path,attrs:{"item":route,"base-path":route.path}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }